// @flow
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { getToken, getStation } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import Page from 'statsradio/components/page/Page';
import DropDownMenu from 'common/components/DropDownMenu';
import DateRange from 'common/domain/DateRange';
import TimerComponent from 'common/components/TimerComponent';
import { withTheme } from 'styled-components';
import Theme from 'statsradio/themes';
import * as Routes from 'statsradio/helpers/constant/Routes';
import StreamingAPI from './services/StreamingAPI';
import StreamMetrics from './domain/StreamMetrics';
import Stream from './domain/Stream';
import StreamLiveMetrics from './domain/StreamLiveMetrics';
import StreamingLiveMtericsHeader from './component/StreamingLiveMetricsHeader';

export const STREAM_SELECTION_PERIOD_ID = 'stream-selection-numberOfDaysSelected';
export const STREAM_METRICS_ID = 'stream-metrics';
export const LIVE_METRICS_TIMER_ID = 'timer-fetching-metrics';
export const EVERY_TEN_SECONDS = 10000;

type Props = {
  callSign: string;
  history: any;
  location: any;
  match: any;
  stream?: Stream;
  t: any;
  theme: typeof Theme;
  token: string;
};

type State = {
  numberOfDaysSelected: number;
  streamMetrics?: StreamMetrics;
  liveMetrics?: StreamLiveMetrics;
}

export class StreamMetricsPage extends Component<Props, State> {

  state = {
    numberOfDaysSelected: 1,
    streamMetrics: undefined,
    liveMetrics: undefined,
  };

  async componentDidMount() {
    this.fetchData();
    this.fetchLiveMetrics();
  }

  async componentDidUpdate(prevProps: Props) {
    if (prevProps.callSign !== this.props.callSign) {
      this.props.history.push({ pathname: Routes.STREAMING });
    }
  }

  onSelectednumberOfDaysSelected = (numberOfDays: number) => {
    this.setState({ numberOfDaysSelected: numberOfDays }, () => this.fetchData());
  }

  async fetchData() {
    const { token, callSign, match } = this.props;
    const reference = match.params.reference;

    const today = moment();
    const period = DateRange.getLastNDays(this.state.numberOfDaysSelected, today);
    const data = await StreamingAPI.fetchMetrics(token, callSign, reference, period);

    this.setState({ streamMetrics: data });
  }

  fetchLiveMetrics = async () => {
    const { token, callSign, match } = this.props;
    const reference = match.params.reference;

    const data = await StreamingAPI.fetchLiveMterics(token, callSign, reference);
    this.setState({ liveMetrics: data });
  }

  render() {
    const { t, theme, stream } = this.props;
    const { numberOfDaysSelected, streamMetrics, liveMetrics } = this.state;


    const numberOfDaysSelections = [
      { label: t('lastNbDays', { count: 1 }), value: 1 },
      { label: t('lastNbDays', { count: 2 }), value: 2 },
      { label: t('lastNbDays', { count: 7 }), value: 7 },
      { label: t('lastNbDays', { count: 14 }), value: 14 },
      { label: t('lastNbDays', { count: 28 }), value: 28 },
    ];

    return (
      <Page useThemeV2 title={t('streamDataPageTitle')}>
        { stream &&
          <div className="row">
            <div className="col-md-4">
              <h4>{t('streamUrl')}</h4><p>{stream.url}</p>
            </div>
            <div className="col-md-4">
              <h4>{t('serverType')}</h4><p>{stream.serverType}</p>
            </div>
            <div className="col-md-4">
              <h4>{t('mediaType')}</h4><p>{stream.mediaType}</p>
            </div>
          </div>
        }

        <div className="col-lg-8 col-xs-4">
          <DropDownMenu
            id={STREAM_SELECTION_PERIOD_ID}
            items={numberOfDaysSelections}
            onChange={this.onSelectednumberOfDaysSelected}
            value={numberOfDaysSelected}
            selectedTextColor={theme.V2.colors.primary}
          />
        </div>

        {liveMetrics &&
        <StreamingLiveMtericsHeader
          liveMetrics={liveMetrics}
        />
        }
        <TimerComponent
          id={LIVE_METRICS_TIMER_ID}
          interval={EVERY_TEN_SECONDS}
          callback={this.fetchLiveMetrics}
        />

        { streamMetrics &&
          <div className="row" id={STREAM_METRICS_ID}>
            <div className="col-md-6">
              <h3>{t('connections')}</h3>
              <h4>{t('uniqueConnections')}</h4><p>{streamMetrics.uniqueConnections}</p>
              <h4>{t('peakConnections')}</h4><p>{streamMetrics.peakConnections}</p>
              <h4>{t('listeningTimeMinutes')}</h4><p>{streamMetrics.listeningTimeMinutes}</p>
              <h4>{t('listeningTimeHours')}</h4><p>{streamMetrics.listeningTimeHours}</p>
            </div>
            <div className="col-md-6">
              <h3>{t('sessions')}</h3>
              <h3>{t('totalSessions')}</h3><p>{streamMetrics.totalSessions}</p>
              <h4>{t('dailyAverageSessions')}</h4><p>{streamMetrics.dailyAverageSessions}</p>
              <h4>{t('hourlyAverageSessions')}</h4><p>{streamMetrics.hourlyAverageSessions}</p>
              <h4>{t('averageSessionDuration')}</h4><p>{streamMetrics.averageSessionDuration}</p>
            </div>
          </div>
        }
      </Page>
    );
  }
}

function mapStateToProps(state, ownProps: Props) {
  const locationState = ownProps.location.state;
  return {
    token: getToken(state),
    callSign: getStation(state),
    stream: locationState ? locationState.stream : undefined,
  };
}

export default withTheme(translate('streaming')(connect(mapStateToProps)(withRouter(StreamMetricsPage))));



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/StreamMetricsPage.js